(function () {
  var moneyFormat = document.querySelector('body').getAttribute('data-money-format');
  var SAMPLE_BUNDLE_DISCOUNT_PERCENT = 70;

  var materialBookAdded = false;
  var materialBookVariantId = null;
  var materialBookPriceCents = 0;

  function formatMoneySmart(cents) {
    var formatted = Shopify.formatMoney(cents, moneyFormat);
    if (cents % 100 === 0) {
      formatted = formatted.replace(/([.,])00(?=\D*$)/, '');
    }
    return formatted;
  }

  function getDrawerEl() {
    return document.querySelector('.orderSample-drawer');
  }

  function getMultiselectWrap() {
    var drawer = getDrawerEl();
    return drawer ? drawer.querySelector('[data-sample-multiselect]') : null;
  }

  function getSelectedSwatches(wrap) {
    if (!wrap) return [];
    return Array.prototype.slice.call(wrap.querySelectorAll('[data-sample-swatch][aria-pressed="true"]'));
  }

  function clearSelection() {
    var wrap = getMultiselectWrap();
    if (!wrap) return;
    wrap.querySelectorAll('[data-sample-swatch][aria-pressed="true"]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.classList.remove('is-selected');
    });
  }

  function getMaterialBookBtn() {
    var drawer = getDrawerEl();
    return drawer ? drawer.querySelector('#materialBookToggleBtn') : null;
  }

  function updateMaterialBookButtonText() {
    var btn = getMaterialBookBtn();
    if (!btn) return;
    if (materialBookAdded) {
      btn.innerHTML = '✓ SELECTED · +' + formatMoneySmart(materialBookPriceCents);
      btn.classList.add('is-added');
    } else {
      btn.innerHTML = btn.dataset.addText || '+ ADD SWATCH BOOK';
      btn.classList.remove('is-added');
    }
  }

  function getAddToCartBtn() {
    var drawer = getDrawerEl();
    return drawer ? drawer.querySelector('#sampleOrder_addto_cart') : null;
  }

  function updateAddToCartButtonText() {
    var btn = getAddToCartBtn();
    if (!btn) return;
    var wrap = getMultiselectWrap();
    var selected = getSelectedSwatches(wrap);

    var prices = [];
    selected.forEach(function (b) {
      var price = parseInt(b.getAttribute('data-price'), 10);
      if (!isNaN(price)) prices.push(price);
    });

    var originalCents = 0;
    var discountedCents = 0;
    if (prices.length) {
      prices.sort(function (a, b) { return b - a; });
      originalCents += prices[0];
      discountedCents += prices[0];
      for (var i = 1; i < prices.length; i++) {
        originalCents += prices[i];
        discountedCents += Math.round(prices[i] * (100 - SAMPLE_BUNDLE_DISCOUNT_PERCENT) / 100);
      }
    }

    if (materialBookAdded) {
      originalCents += materialBookPriceCents;
      discountedCents += materialBookPriceCents;
    }

    if (selected.length === 0) {
      btn.disabled = true;
      btn.innerHTML = 'Select a sample';
      return;
    }

    btn.disabled = false;

    if (prices.length > 1) {
      btn.innerHTML =
        'Add To Cart &nbsp;|&nbsp; <s class="sample-price-original">' + formatMoneySmart(originalCents) + '</s> ' + formatMoneySmart(discountedCents);
    } else {
      btn.innerHTML = 'Add To Cart &nbsp;|&nbsp; ' + formatMoneySmart(discountedCents);
    }
  }

  function showToast(sampleName) {
    var drawer = getDrawerEl();
    if (!drawer) return;
    var toast = drawer.querySelector('#sampleAddedToast');
    var toastText = drawer.querySelector('#sampleAddedToastText');
    if (!toast || !toastText) return;
    toastText.innerHTML = "A sample of '" + sampleName + "' has been added to your cart ";
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 5000);
  }

  function updateSampleCartCount() {
    fetch('/cart.js?_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.thb-item-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('Cart count update error:', err);
      });
  }

function getOverlayEl() {
    return document.querySelector('.orderSample-drawer-overlay');
  }

  function openDrawer() {
    document.body.classList.add('open-cc');
    var drawer = getDrawerEl();
    var overlay = getOverlayEl();
    if (drawer) drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
  }

  function closeDrawer() {
    document.body.classList.remove('open-cc');
    var drawer = getDrawerEl();
    var overlay = getOverlayEl();
    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
  }

  function resetState() {
    materialBookAdded = false;
    clearSelection();
    updateMaterialBookButtonText();
    updateAddToCartButtonText();
  }

function ensureLoadingStyles() {
    if (document.getElementById('OrderSampleLoadingStyles')) return;
    var style = document.createElement('style');
    style.id = 'OrderSampleLoadingStyles';
    style.textContent =
      '.orderSample-drawer-loading{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;gap:16px;padding:60px 20px;text-align:center;}' +
      '.orderSample-drawer-loading__spinner{width:40px;height:40px;border:4px solid rgba(0,0,0,0.15);border-top-color:currentColor;border-radius:50%;animation:orderSampleSpin 0.8s linear infinite;}' +
      '@keyframes orderSampleSpin{to{transform:rotate(360deg);}}';
    document.head.appendChild(style);
  }

  function showDrawerLoadingState(drawerEl) {
    drawerEl.innerHTML =
      '<div class="orderSample-drawer-loading">' +
        '<span class="orderSample-drawer-loading__spinner"></span>' +
        '<p>Loading sample options&hellip;</p>' +
      '</div>';
  }

  function showDrawerErrorState(drawerEl) {
    drawerEl.innerHTML =
      '<div class="orderSample-drawer-loading">' +
        '<p>Sorry, something went wrong loading this product\'s samples. Please try again.</p>' +
      '</div>';
  }

  function loadAndOpenDrawer(handle, triggerBtn) {
    if (!handle) return;
    var drawerEl = getDrawerEl();
    if (!drawerEl) return;

    if (triggerBtn) triggerBtn.classList.add('loading');

    ensureLoadingStyles();
    showDrawerLoadingState(drawerEl);
    openDrawer();

    fetch('/products/' + handle)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var sourceDrawer = parsed.querySelector('.orderSample-drawer-wrapper .orderSample-drawer');

        if (!sourceDrawer) {
          console.error('Order sample drawer markup not found for product:', handle);
          showDrawerErrorState(drawerEl);
          return;
        }

        drawerEl.innerHTML = sourceDrawer.innerHTML;
        
        var scripts = drawerEl.querySelectorAll('script');
        scripts.forEach(function (oldScript) {
          var newScript = document.createElement('script');
          if (oldScript.src) {
            newScript.src = oldScript.src;
          } else {
            newScript.textContent = oldScript.textContent;
          }
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
        document.querySelectorAll('[data-order-sample-injected-modal]').forEach(function (el) {
          el.remove();
        });

        drawerEl.querySelectorAll('[data-modal]').forEach(function (opener) {
          var selector = opener.dataset.modal;
          if (!selector || document.querySelector(selector)) return;

          var sourceModal = parsed.querySelector(selector);
          if (!sourceModal) return;

          var clone = sourceModal.cloneNode(true);
          clone.setAttribute('data-order-sample-injected-modal', 'true');
          document.body.appendChild(clone);
        });

        var bookBtn = drawerEl.querySelector('#materialBookToggleBtn');
        materialBookVariantId = bookBtn ? parseInt(bookBtn.dataset.variantId, 10) : null;
        materialBookPriceCents = bookBtn ? parseInt(bookBtn.dataset.price, 10) : 0;

        resetState();
        openDrawer();
      })
      .catch(function (err) {
        console.error('Error loading order sample drawer:', err);
        showDrawerErrorState(drawerEl);
      })
      .finally(function () {
        if (triggerBtn) triggerBtn.classList.remove('loading');
      });
  }

  function addSamplesToCart(btn) {
    var wrap = getMultiselectWrap();
    var selected = getSelectedSwatches(wrap);

    var items = [];
    selected.forEach(function (b) {
      var variantId = b.getAttribute('data-variant-id');
      if (variantId) items.push({ id: parseInt(variantId, 10), quantity: 1 });
    });
    if (!items.length) return;

    if (materialBookAdded && materialBookVariantId) {
      items.push({ id: materialBookVariantId, quantity: 1 });
    }

    btn.disabled = true;
    var originalText = btn.innerHTML;
    btn.innerHTML = '<span class="sample-cart-loader"></span> Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status == 422) {
          btn.disabled = false;
          btn.innerHTML = originalText;
          return;
        }

        clearSelection();
        materialBookAdded = false;
        updateMaterialBookButtonText();
        updateSampleCartCount();

        var label = items.length === 1 ? '1 sample' : items.length + ' samples';
        showToast(label);

        updateAddToCartButtonText();
      })
      .catch(function (err) {
        console.error('Error adding samples to cart:', err);
        btn.disabled = false;
        btn.innerHTML = originalText;
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.collection-order-sample-btn');
    if (trigger) {
      e.preventDefault();
      loadAndOpenDrawer(trigger.dataset.productHandle, trigger);
      return;
    }

    if (e.target.closest('.orderSample-drawer-overlay')) {
      closeDrawer();
      return;
    }

    if (e.target.closest('.orderSample-drawer .sample-cross-btn, .orderSample-drawer .btn-continue-shop')) {
      closeDrawer();
      return;
    }

    var materialBtn = e.target.closest('.orderSample-drawer #materialBookToggleBtn');
    if (materialBtn) {
      materialBookAdded = !materialBookAdded;
      updateMaterialBookButtonText();
      updateAddToCartButtonText();
      return;
    }

    var swatchBtn = e.target.closest('.orderSample-drawer [data-sample-swatch]');
    if (swatchBtn && !swatchBtn.disabled) {
      var isSelected = swatchBtn.getAttribute('aria-pressed') === 'true';
      swatchBtn.setAttribute('aria-pressed', isSelected ? 'false' : 'true');
      swatchBtn.classList.toggle('is-selected', !isSelected);
      updateAddToCartButtonText();
      return;
    }

    var addToCartBtn = e.target.closest('.orderSample-drawer #sampleOrder_addto_cart');
    if (addToCartBtn && !addToCartBtn.disabled) {
      addSamplesToCart(addToCartBtn);
      return;
    }
  });
})();